import { render, staticRenderFns } from "./PhaseTypeSingle.vue?vue&type=template&id=88d7a5a0&scoped=true"
import script from "./PhaseTypeSingle.vue?vue&type=script&lang=js"
export * from "./PhaseTypeSingle.vue?vue&type=script&lang=js"
import style0 from "./PhaseTypeSingle.vue?vue&type=style&index=0&id=88d7a5a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d7a5a0",
  null
  
)

export default component.exports